module.exports = __webpack_public_path__ + "img/logo.762d0075.webp";